// src/components/MfaVerification.js
import React, { useState } from 'react';
import {useNavigate} from "react-router-dom";
import axios from "axios";

function MfaVerification({ onAuthenticationSuccess }) {
    const [mfaCode, setMfaCode] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const handleMfaVerify = async () => {
        try {
            console.log('Sending MFA code:', mfaCode);
            await axios.post(baseURL + '/auth/mfa-verify',
                { mfaCode },
                {
                    withCredentials: true // Wichtig für Cookies und Sitzungen
                }
            );
            console.log('MFA verification successful');

            // Nach erfolgreicher Verifizierung zum Dashboard navigieren
            navigate('/dashboard');
        } catch (error) {
            setError('MFA-Verifizierung fehlgeschlagen. Bitte überprüfen Sie Ihren Code.');
            navigate('/login', { state: { error: 'MFA-Verifizierung fehlgeschlagen. Bitte loggen Sie sich erneut ein und warten sie auf einen neuen Code.' } });

        }
    };

    return (
        <div className="min-h-screen w-full bg-black flex flex-col items-center justify-center p-4">
            <div className="w-[90%] max-w-md mx-auto flex flex-col items-center justify-center">
                {/* Header */}
                <h2 className="text-white text-2xl mb-6">MFA-Code eingeben</h2>

                {/* Error Message */}
                {error && <p className="text-red-500 mb-4">{error}</p>}

                {/* MFA Input */}
                <div className="w-full flex justify-center mb-6">
                    <input
                        type="text"
                        placeholder="6-stelliger MFA-Code"
                        value={mfaCode}
                        onChange={(e) => setMfaCode(e.target.value)}
                        className="w-full px-4 py-2 bg-[#D9D9D9] rounded text-center focus:outline-none focus:ring-2 focus:500"
                    />
                </div>

                {/* Confirm Button */}
                <div className="w-full flex justify-center">
                    <button
                        onClick={handleMfaVerify}
                        className="w-full py-2 rounded bg-blue-700 hover:bg-teal-400 text-white focus:outline-none transition duration-150"
                    >
                        Bestätigen
                    </button>
                </div>
            </div>
        </div>
    );

}

export default MfaVerification;
